import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetObservationsByReferenceProps = {
  referenceId: string;
  referenceType: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getObservationsByReference =
  ({
    referenceId,
    referenceType,
    params = {},
    signal,
  }: GetObservationsByReferenceProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/observations/reference`, {
        params: {
          referenceId,
          referenceType,
          ...params,
        },
        // signal,
      });
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
